import React from 'react';
import ReactLoading from 'react-loading';

const IndicatorLoading = ({type="spinningBubbles", color="#f0ad4e", width="45px", height="45px", delay = 10}) => (


    <ReactLoading type={type}
                    color={color}
                    width={width}
                    height={height}
                    className = "loading-indicator"
                    delay={10} />

);
export default IndicatorLoading;



// WEBPACK FOOTER //
// ./src/components/indicatorLoading/IndicatorLoading.js